//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconArrowLineLeft(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M6 18H8V6H6V18ZM18.34 6H15.73L10.73 12L15.73 18H18.34L13.34 12L18.34 6Z" fill="currentColor" /></svg>;
}
export default IconArrowLineLeft;